
((VStroker, $) => {
  'use strict';

  const sliderOptions = {
    autoplay: true,
    autoplaySpeed: 1000,
    scrollSpeed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
    infinite: true,
    arrows: true,
    prevArrow: '<button class="review-slider-button slider--prev flex-row"><i class="fa fa-chevron-left"></i></button>',
    nextArrow: '<button class="review-slider-button slider--next flex-row"><i class="fa fa-chevron-right"></i></button>',
    responsive: [
      {
        breakpoint: 992,
        settings: {
          autoplaySpeed: 3000,
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  };

  let $slider;
  let $sliderButtonsContainer;
  let $sliderButtons;
  let firstPause = false;

  const sliderInit = () => {
    $slider.slick(sliderOptions);
  };

  const sliderPause = (index) => {
    if (!firstPause) {
      $slider.slick('slickGoTo', index);
      $slider.slick('slickPause');
      firstPause = true;
    } else if ($slider.slick('slickCurrentSlide') === index) {
      $slider.slick('slickPlay');
    } else {
      $slider.slick('slickGoTo', index);
      $slider.slick('slickPause');
    }
  };

  const cacheDom = () => {
    $slider = $('.vstroker-star-pick-slider');
    $sliderButtonsContainer = $('.vstroker-slider-selectors');
    $sliderButtons = $sliderButtonsContainer.find('.vstroker-slider-selector-name');
  };

  const bindUIActions = () => {
    $sliderButtons.on('click', function toggleClass() {
      const index = parseInt($(this).data('index'), 10);
      sliderPause(index);

      if ($(this).hasClass('vstroker-slider-selector-name-active')) {
        $sliderButtons.removeClass('vstroker-slider-selector-name-active');
      } else {
        $sliderButtons.removeClass('vstroker-slider-selector-name-active');
        $(this).addClass('vstroker-slider-selector-name-active');
      }
    });

    $slider.on('swipe', function swipePlay() {
      $sliderButtons.removeClass('vstroker-slider-selector-name-active');
      $(this).slick('slickPlay');
    });

    $sliderButtonsContainer.on('mouseenter', () => {
      $slider.slick('slickPause');
    });

    $sliderButtonsContainer.on('mouseleave', () => {
      if (!$sliderButtons.hasClass('vstroker-slider-selector-name-active')) {
        $slider.slick('slickPlay');
      }
    });
  };

  const init = () => {
    cacheDom();
    sliderInit();
    bindUIActions();
  };

  VStroker.init = init;
})(window.VStroker = window.VStroker || {}, jQuery);
